import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import Button from "../../../../Button";
import { jsx as _jsx } from "react/jsx-runtime";
function ButtonCell(props) {
  return /*#__PURE__*/_jsx(Button, _extends({}, props, {
    size: "compact"
  }));
}
ButtonCell.displayName = "ButtonCell";
export default ButtonCell;